export const GET_TOKEN = "getToken";
export const LOGOUT = "logout";
export const SET_TITLE = "setTitle";
export const HIDE_NAV = "hideNav";
export const HIDE_BACK = "hideBack";
export const UPDATE_INFO = "updateInfo";
export const GET_DICT = "getDict";
export const CONFIRM_SELECT = "confirmSelect";
export const UNSEL_ADDRESS = "unselAddress";
export const DEL_ADDRESS = "delAddress";
export const MODIFY_ADDRESS = "modifyAddress";
